module.exports = __webpack_public_path__ + "static/img/fw_ry.c773f4e8.png";